import React from 'react'
import Router from './router'
import applicationData from './components/applicationContext/applicationData'

import './app.css'

const App = props => <Router {...props} />

export default applicationData(App)
